import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "../axiosInstance";

export interface MemberData {
    member_idx: number;
    m_name: string;
    m_email: string;
    m_mobile: string;
    m_level: number;
    m_category: number;
    reg_date: string;
    customer_idx: number;
    customer_name: string;
    order_count: number;
    total_sales_amount: number;
}

interface GetMemberResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: MemberData[];
}

export const useGetMember = (
    page: number,
    pageSize: number,
    search?: string,
    searchtxt?: string,
    field?: string,
    direction?: string,
): UseQueryResult<GetMemberResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemberResponse, Error>({
        queryKey: ["getMemberList", page, pageSize, search, searchtxt, field, direction],
        queryFn: async () => {
            const encodedSearchTxt = encodeURIComponent(searchtxt || "");
            const url = `${enum_api_uri.get_member}?page=${page}&limit=${pageSize}&search=${search}&searchtxt=${encodedSearchTxt}&field=${field}&direction=${direction}`;

            const response = await axiosInstance.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
